import { render, staticRenderFns } from "./MoleculeBuildingSelectedSpaceDetails.vue?vue&type=template&id=49cdd076&"
import script from "./MoleculeBuildingSelectedSpaceDetails.vue?vue&type=script&lang=js&"
export * from "./MoleculeBuildingSelectedSpaceDetails.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeBuildingSelectedSpaceDetails.vue?vue&type=style&index=0&id=49cdd076&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismSelectedSpaceMobile.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeBuildingSelectedSpaceDetails.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingV2MoleculeSidebarResultSpaceDetails: require('/app/components/molecules/project/buildingV2/MoleculeSidebarResultSpaceDetails.vue').default,AtomsCommonAtomSimpleButton: require('/app/components/atoms/common/AtomSimpleButton.vue').default,MoleculesProjectBuildingV2MoleculeAvailabilitySpaceFilterResultCombinedSpace: require('/app/components/molecules/project/buildingV2/MoleculeAvailabilitySpaceFilterResultCombinedSpace.vue').default,MoleculesProjectMoleculeContractDetailsContainer: require('/app/components/molecules/project/MoleculeContractDetailsContainer.vue').default})
